import { render, staticRenderFns } from "./BlockFields.vue?vue&type=template&id=5498f2b6&scoped=true&"
import script from "./BlockFields.vue?vue&type=script&lang=js&"
export * from "./BlockFields.vue?vue&type=script&lang=js&"
import style0 from "./BlockFields.vue?vue&type=style&index=0&id=5498f2b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5498f2b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VBtnToggle,VIcon,VSelect,VSpacer,VTextField,VTextarea})
